import { render, staticRenderFns } from "./equipmentsLDistributionInfoWindow.vue?vue&type=template&id=54985376&scoped=true&"
import script from "./equipmentsLDistributionInfoWindow.vue?vue&type=script&lang=js&"
export * from "./equipmentsLDistributionInfoWindow.vue?vue&type=script&lang=js&"
import style0 from "./equipmentsLDistributionInfoWindow.vue?vue&type=style&index=0&id=54985376&lang=scss&"
import style1 from "./equipmentsLDistributionInfoWindow.vue?vue&type=style&index=1&id=54985376&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54985376",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54985376')) {
      api.createRecord('54985376', component.options)
    } else {
      api.reload('54985376', component.options)
    }
    module.hot.accept("./equipmentsLDistributionInfoWindow.vue?vue&type=template&id=54985376&scoped=true&", function () {
      api.rerender('54985376', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newDashboard/components/distribution/equipmentsLDistributionInfoWindow.vue"
export default component.exports